const _excluded = ["useBeacon"],
      _excluded2 = ["options"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import ApiBase from './base';
export default class Interactions extends ApiBase {
  constructor(api) {
    super(api, 'interactions');
  }

  async upload(payload, options) {
    try {
      return await this._run('upload', payload, options);
    } catch (e) {
      if (e.status === 400 && e.message && e.message.toLowerCase().indexOf('playground') > -1) {
        this._warn(`Ignore interactions uploaded to playground app.`);
      } else {
        throw e;
      }
    }
  }

  _url(_ref) {
    let {
      apiGroup,
      apiName
    } = _ref;
    const url = this.helpers.url(this._apiPath);
    return this.helpers.applyUrlPasses(this, {
      apiGroup,
      apiName,
      url
    });
  }

  _preprocess(_ref2) {
    let {
      apiGroup,
      apiName,
      payload
    } = _ref2;

    if (apiName === 'upload') {
      payload = this._normalizeUploadPayload(payload);
    }

    return super._preprocess({
      apiGroup,
      apiName,
      payload
    });
  }

  _normalizeUploadPayload(payload) {
    // TODO: accept string as a shortcut of { type: payload } as well
    if (typeof payload !== 'object') {
      throw new Error(`Interactions payload has to be either an object or an array of objects: ${payload}`);
    }

    if (!Array.isArray(payload)) {
      payload = [payload];
    }

    return {
      data: payload
    };
  }

  async _send(_ref3) {
    let {
      options: {
        useBeacon = true
      } = {}
    } = _ref3,
        options = _objectWithoutPropertiesLoose(_ref3.options, _excluded),
        args = _objectWithoutPropertiesLoose(_ref3, _excluded2);

    if (useBeacon) {
      const {
        url,
        payload
      } = args;
      this.helpers.sendBeacon(url, payload, options);
      return {};
    } else {
      return super._send(Object.assign({}, args, {
        options
      }));
    }
  }

}